import { type ReactNode } from "react";
import { Table } from "react-bootstrap";

import { ReportColumnProps, SortConfig } from "src/types/report";
import NoDataFound from "../common/NoDataFound";
import { formatValue } from "src/helpers/Report";

type DataRow = Record<string, unknown>;

type DataTableProps = {
  isReportLoading: boolean;
  reportHeader: ReportColumnProps[];
  reportData: DataRow[];
  sortConfig: SortConfig;
  onSort: (column: string) => void;
};

export default function DataTable({
  isReportLoading,
  reportHeader,
  reportData,
  sortConfig,
  onSort,
}: DataTableProps) {
  const onHeaderClick = (column: ReportColumnProps) => {
    if (!column.sortable) return;
    onSort(column.key);
  };

  return (
    <Table
      striped
      hover
      responsive
      className="overflow-auto report-data-table"
      style={{ maxHeight:"600px", minHeight:"600px" }}
    >
      <thead className="sticky-top z-1">
        <tr className="text-center">
          {reportData.length > 0 &&
            reportHeader.map((column) => (
              <th style={{ whiteSpace: "nowrap" }} key={column.key}>
                <span
                  role="button"
                  onClick={() => onHeaderClick(column)}
                  className={`btn btn-link p-0 table-header-link ${!column.sortable ? "pe-none" : ""}`}
                >
                  {column.label}
                  {column.sortable &&
                    sortConfig?.column === column.key &&
                    (sortConfig.direction === "desc" ? (
                      <i className="bi bi-caret-down-fill ms-1"></i>
                    ) : (
                      <i className="bi bi-caret-up-fill ms-1"></i>
                    ))}
                </span>
              </th>
            ))}
        </tr>
      </thead>
      <tbody>
        {isReportLoading ? (
          [...Array(5).keys()].map((_, index) => (
            <tr className="table-row" key={index}>
              {reportHeader.map((column) => (
                <td key={column.key} className="placeholder-glow">
                  <span className="placeholder placeholder-sm w-100"></span>
                </td>
              ))}
            </tr>
          ))
        ) : reportData.length > 0 ? (
          reportData.map((row, index: number) => (
            <tr
              className="table-row"
              key={(row.id as string | number | undefined) ?? index}
            >
              {reportHeader.map((column) => (
                <td key={column.key} className="text-center">
                  <span className="report-data-table-cell-content d-block">
                    {(formatValue(row[column.key]) as ReactNode) ?? "-"}
                  </span>
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td className="bg-white border-0">
              <NoDataFound />
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
}
